// Day Care module constants (spec: daycare-files/DAYCARE-SPEC.md).

import BloodtypeIcon from "@mui/icons-material/Bloodtype";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AssignmentIcon from "@mui/icons-material/Assignment";
import SettingsIcon from "@mui/icons-material/Settings";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";

/** Base path for all Day Care routes — change here only. */
export const DAYCARE_BASE = "/daycare";

/** Unit work (book, check in, chart, discharge steps). */
export const PERM_BOARD = "daycare_board";
/** Unit setup (wards, services, shifts, machines, package). */
export const PERM_ADMIN = "daycare_admin";

/** The module sidebar, in the shape ModuleSidebarLayout reads (inventory/navigation.js).
 *  An item's `permission` hides it from anyone without it; the route refuses them too. */
export const NAV_CONFIG = {
  key: "daycare",
  base: "",
  title: "Day Care",
  subtitle: "Same-day admissions",
  icon: BloodtypeIcon,
  groups: [
    {
      id: "workspace",
      label: "Workspace",
      items: [
        { id: "board", label: "Today's board", icon: DashboardIcon, path: DAYCARE_BASE, match: [`${DAYCARE_BASE}/session`] },
        { id: "orders", label: "Course orders", icon: AssignmentIcon, path: `${DAYCARE_BASE}/orders` },
      ],
    },
    {
      id: "admin",
      label: "Administration",
      items: [
        { id: "setup", label: "Unit setup", icon: SettingsIcon, path: `${DAYCARE_BASE}/setup`, permission: PERM_ADMIN },
      ],
    },
  ],
  footer: [
    { id: "go-home", label: "IPD Home", icon: LocalHospitalIcon, href: "/main-landing" },
  ],
};

/** main_ipd_admission.status values the module reads (the IPD module keeps them as literals). */
export const ADMISSION_STATUS = {
  ALLOCATED: "Allocated",
  DISCHARGED: "Discharged",
};

/** main_bedstatus names of a machine's bed, with the board's label and tone. */
export const BED_AVAILABLE = "available";
export const BED_STATUS_VIEW = {
  available: { label: "Available", tone: "good" },
  occupied: { label: "In use", tone: "info" },
  reserved: { label: "Reserved", tone: "info" },
  cleaning: { label: "Cleaning", tone: "warn" },
  maintenance: { label: "Maintenance", tone: "bad" },
};

export const SESSION_STATUS = {
  BOOKED: "BOOKED",
  ADMITTED: "ADMITTED",
  CONVERTED: "CONVERTED",
  DNA: "DNA",
  CANCELLED: "CANCELLED",
};

/** Machine infection groups, clean first. */
export const GROUP_CLEAN = "CLEAN";
export const VIRAL_GROUPS = [GROUP_CLEAN, "HBSAG", "HCV", "HIV"];
export const MARKER_VALUES = ["NEGATIVE", "POSITIVE"];

export const CHART_TYPE = { NONE: "NONE", DIALYSIS: "DIALYSIS" };

export const CHART_TYPES = [
  { value: CHART_TYPE.NONE, label: "No session chart" },
  { value: CHART_TYPE.DIALYSIS, label: "Dialysis flowsheet" },
];

export const ORDER_STATUS = { ACTIVE: "ACTIVE", STOPPED: "STOPPED" };

/** How a course ends: after a number of sessions, or on a date. */
export const END_MODE = { COUNT: "COUNT", DATE: "DATE" };

/** date.weekday() numbering, as the backend stores repeat days. */
export const WEEKDAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const ACCESS_TYPES = ["AVF", "AVG", "CVC"];
